const constants = {
  otpMaxLength: 4,
  otpInitialLength: 0,
  otpTimer: 60,
  minimumAge: 18,
  dateFormat: "DD/MM/YYYY",
  dateTimeFormat: "DD/MM/YYYY HH:mm",
  imageType: "image/jpeg, image/jpg, image/png",
  videoType: "video/*",
  audioType: "audio/mp3",
  loggedInUser: "",
  User: "User",
  supportEailId: "mailto:support@sekeron.com",
  userDetails: "userDetails",

  // timer
  thousandMilliSeconds: 1000,
  threeSeconds: 3000,
  fourHundredSeconds: 4000,
  fiveHundredSeconds: 5000,
  tenThousandSeconds: 10000,
};

export default constants;
